import { Component, OnInit, Inject, Optional } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'cellRender-key',
    templateUrl: './cellRender-key.component.html'
})
export class CellRenderKeyComponent implements OnInit {

    params: any;
    key: string = '';
    keyLegend: string = '';
    tooltip: string = '';
    cellClass: string = '';
    index: number;
    gridIndex: number;
    deviceType: any;
    isGroup: false;

    constructor(
        private translationService: PershingTranslationService,
        @Optional() @Inject('AppSettings') appSettings: any
    ) { 
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');
        this.deviceType = appSettings.deviceType;
    }

    agInit(params: any) {
        this.params = params;
        this.isGroup = this.params.node.__hasChildren;
    }

    ngOnInit() {
        this.key = !!this.params && this.params.value ? this.params.value : '';
        this.tooltip = !!this.params && !!this.params.data && !!this.params.data.tooltip ? this.params.data.tooltip : '';
        this.cellClass = !!this.params && !!this.params.data && !!this.params.data.tooltip ? this.params.data.class : '';
        this.keyLegend = !!this.params && !!this.params.data && !!this.params.data.legend ? this.params.data.legend : '';
        this.index = !!this.params && this.params.rowIndex ? this.params.rowIndex : 0;
        this.gridIndex = ((this.index * 2 < 10) ? (this.index * 2) : (this.index * 2 - 10));
    }
}
